const store = {
    namespaced: true,
    state: {
        operators: [],
        label_infos: [],
        core_waybill_payment_types: [
            {
                "name": "到付",
                "value": "到付",
                // "value": "cash_by_consignee",
            },{
                "name": "寄付",
                "value": "寄付",
                // "value": "cash_by_sender",
            },{
                "name": "月結",
                "value": "月結",
                // "value": "monthly",
            }
        ],
    },
    getters: {
        get_operator_name(state, getters, rootState, rootGetters) {
            return (identity) => {
                let reslut = _.findLast(state.operators, (operator) => {
                    return operator.identity == identity
                }) || null

                if (reslut) {
                    if (reslut.name) return reslut.name
                    if (reslut.company_name) return reslut.company_name
                }
                return false
            }
        },
    },
    actions: {
        fetch_staff(context, payload) {
            if (
                !_.find(context.state.staffs, (staff) => {
                    return staff.identity == payload.operator_identity
                })
            ) {
                var rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_staff)
                var url = rest_url.parse({
                    "identity": payload.operator_identity,
                })

                return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        context.commit('set_operators', response.data.staff)
                    })
                    .catch(error => {
                        console.log('Failed to fetch CustomerNodes.')
                        return Promise.reject(error)
                    })
            }
            return ""
        },
        fetch_customer(context, payload) {
            if (
                !_.find(context.state.customers, (customer) => {
                    return customer.identity == payload.operator_identity
                })
            ) {
                var rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_customer)
                var url = rest_url.parse({
                    customer_identity: payload.operator_identity,
                })

                return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        context.commit('set_operators', response.data.customer)
                    })
                    .catch(error => {
                        console.log('Failed to fetch CustomerNodes.')
                        return Promise.reject(error)
                    })
            }
            return ""
        },
    },
    mutations: {
        set_operators(state, payload) {
            state.operators.push(payload)
        },
    }
}

export default store
